import type { DeleteTagTypesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteTagTypesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteTagTypes = createMutationHook({
  name: 'deleteTagTypes',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.tag.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  invalidate: (trpc) => [trpc.frontend.tag.pathKey()],
  mapResponse: (result: { affected_rows: number }): DeleteTagTypesMutation => ({
    deleteTagTypeApi: {
      __typename: 'GenericMutationOutput',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: DeleteTagTypesDocument,
  graphqlVariables: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  evictFields: ['tag_type'],
});
